import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { useAuth } from '@contexts/auth';
import { useScreenSize } from '@hooks/useScreenSize';
import { defaultAvatarUrl } from '@utils';
import Image from 'next/image';

const SessionAvatar = ({ glassLogin = false }) => {
  const { session, isLoading, isAuth0Loading, logOut } = useAuth();
  const { isDesktop } = useScreenSize();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  // Manejador para cerrar el dropdown si se hace click fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // No renderizar en dispositivos que no sean de escritorio
  if (!isDesktop) return null;

  // Renderizar mientras carga
  if (isLoading || isAuth0Loading) {
    return <div className="bg-gray-200 animate-pulse rounded-full w-10 h-10 ring-2 ring-gray-200/60 ring-offset-2 ring-offset-white/80" />;
  }

  // Renderizar si la sesión existe
  if (session) {
    return (
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="flex items-center justify-center w-10 h-10 rounded-full overflow-hidden ring-2 ring-primary-400/60 ring-offset-2 ring-offset-white/80 hover:ring-primary-500 transition-all duration-300 shadow-sm hover:shadow-md"
        >
          <Image
            src={session?.avatar_url ? session?.avatar_url : defaultAvatarUrl}
            fill
            sizes="40px"
            className="rounded-full object-cover"
            alt="Profile avatar"
          />
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-3 w-52 rounded-2xl z-20 overflow-hidden dropdown-glass">
            <div className="p-1.5">
              <Link
                href={session?.vendor?.is_onboarding_finished ? '/perfil' : '/onboarding'}
                className="block px-4 py-2.5 text-sm font-medium text-gray-700 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200"
              >
                {session?.vendor?.is_onboarding_finished ? 'Mi perfil' : 'Completar perfil'}
              </Link>
              <span
                className="block px-4 py-2.5 text-sm font-medium text-gray-700 rounded-xl hover:bg-gray-50 hover:text-gray-900 cursor-pointer transition-all duration-200"
                onClick={logOut}
              >
                Desconectarse
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Renderizar botón de iniciar sesión si no hay sesión
  // Sobre la portada, «Ingresar» va en una píldora de vidrio; en las demás barras, como texto.
  return (
    <div className="topbar__session">
      <Link href="/signin" className={glassLogin ? 'topbar__login topbar__login--glass' : 'topbar__login'}>
        Ingresar
      </Link>
      <Link href="/signup" className="topbar__cta">
        Agregá tu negocio
      </Link>
    </div>
  );
};

export default SessionAvatar;
